'use client';

import { Dialog, DialogContent } from '#/components/ui/dialog';
import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import { useConfiguredChainId } from '#/data/wagmi/configured';
import { consolidationConfig } from '#/lib/generated';
import { handleTransactionError } from '#/lib/handle-transaction-error';
import { cn } from '#/lib/utils';
import { DialogContentProps, DialogProps } from '@radix-ui/react-dialog';
import { captureException } from '@sentry/nextjs';
import { useInterpret } from '@xstate/react';
import invariant from 'invariant';
import { concat, parseUnits } from 'viem';
import { useSendTransaction } from 'wagmi';
import machine, { MachineContext } from './contexts/machine';
import { Information } from './information';

interface Props {
  originalRow: EthereumStakingValidatorInfo;
}
function DialogContentImpl({ originalRow: target }: Props) {
  const chainId = useConfiguredChainId();
  const {
    sendTransactionAsync,
    data: transactionHash,
    isSuccess,
    isPending,
  } = useSendTransaction();

  const interpreter = useInterpret(machine, {
    context: {
      target,
    },
    services: {
      onTransaction: async (context, event) => {
        console.log('====================================');
        console.log('onTransaction', context);
        console.log('====================================');
        const { target } = context;
        invariant(target != null, 'target is required');
        try {
          const data = concat([target.pubKey, target.pubKey]); // source + target, is it self

          const transactionHash = await sendTransactionAsync({
            to: consolidationConfig.address(chainId),
            value: parseUnits('1', 0), // 1wei
            data,
          });

          console.log('====================================');
          console.log('Transaction Success', transactionHash);
          console.log('====================================');

          return { transactionHash };
        } catch (error) {
          handleTransactionError(error);
          captureException(error);
          throw error;
        }
      },
    },
  });

  return (
    <MachineContext.Provider value={interpreter}>
      <Information />
    </MachineContext.Provider>
  );
}
export function UpgradeDialogContent({
  originalRow,
  className,
  ...props
}: Props & DialogContentProps) {
  return (
    <DialogContent
      {...props}
      className={cn(
        'sm:max-w-(--breakpoint-sm) overflow-y-scroll max-h-screen',
        className
      )}
    >
      <DialogContentImpl originalRow={originalRow} />
    </DialogContent>
  );
}
export function UpgradeDialog({ originalRow, ...props }: Props & DialogProps) {
  return (
    <Dialog {...props}>
      <UpgradeDialogContent originalRow={originalRow} />
    </Dialog>
  );
}
